import { createAction } from "@logicsoftware/redux-toolkit";
import { UpdatingItem } from "../types";
import { UpdateResponse } from "./types";

enum ActionTypes {
    ITEM_UPDATE_STARTED = "TASK_PROJECT/ITEM_UPDATE_STARTED",
    ITEM_UPDATE_COMPLETED = "TASK_PROJECT/ITEM_UPDATE_COMPLETED",
    ITEM_UPDATE_FAILED = "TASK_PROJECT/ITEM_UPDATE_FAILED",
}

export type DetailsUpdatedEvent<TPayload = any> = {
    affectedProjectIds?: number[];
    affectedTaskIds?: number[];
    item?: UpdatingItem;
    hasPendingUpdates?: boolean;
    fireAndForget?: boolean;
    requestPayload?: TPayload;
    url?: string;
    response?: UpdateResponse;
    isBatchUpdate?: boolean;
    operationId?: string;
    isRedo?: boolean;
};

export const updateStarted = (data: DetailsUpdatedEvent) =>
    ({
        type: ActionTypes.ITEM_UPDATE_STARTED,
        data,
    } as const);
updateStarted.toString = () => ActionTypes.ITEM_UPDATE_STARTED;

export type UpdateCompleted = ReturnType<typeof updateCompleted>;
export const updateCompleted = (data: DetailsUpdatedEvent) =>
    ({
        type: ActionTypes.ITEM_UPDATE_COMPLETED,
        data,
    } as const);
updateCompleted.toString = () => ActionTypes.ITEM_UPDATE_COMPLETED;

export const updateFailed = (data: DetailsUpdatedEvent) =>
    ({
        type: ActionTypes.ITEM_UPDATE_FAILED,
        data,
    } as const);
updateFailed.toString = () => ActionTypes.ITEM_UPDATE_FAILED;

export const projectsDeleted = createAction("TASK_PROJECT/PROJECTS_DELETED", (projectIds: number[]) => ({
    payload: { projectIds },
}));
